(function () {
const $bebb4b13869e9a78$var$flowbitePlugin = window.Flowbite.Plugin;
const $bebb4b13869e9a78$var$config = {
    content: [
        "./index.html",
        "./node_modules/flowbite/**/*.js"
    ],
    plugins: [
        $bebb4b13869e9a78$var$flowbitePlugin
    ]
};
var $bebb4b13869e9a78$export$2e2bcd8739ae039 = $bebb4b13869e9a78$var$config;

})();
//# sourceMappingURL=index.313dd126.js.map
